import React from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ReactTyped } from "react-typed";

const Landing = () => {
    const { t } = useTranslation();

    return (
        <div className="h-res-80 relative h-[100vh] w-full overflow-hidden">
            <video
                autoPlay
                loop
                muted
                playsInline
                className="absolute top-0 left-0 w-full h-full object-cover transform scale-100 transition-transform duration-[20s] hover:scale-105"
                poster={require("../../assets/company/DSC00010.JPG")}
            >
                <source src="https://alburoujplast.com/landing.mp4" type="video/mp4" />
            </video>

            <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>

            <div className="px-4 sm:px-8 md:px-16 lg:px-[150px] relative z-10 flex flex-col justify-center h-full text-white">
                <div className="text-center flex flex-col justify-center gap-6 max-w-4xl mx-auto">
                    <h1 className="text-st-ar text-center text-4xl sm:text-5xl md:text-6xl font-extrabold font-f animate-fade-in-down leading-tight">
                        {t("Hadaret alburouj for plastic industries")}
                    </h1>
                    <div className="text-lg sm:text-xl md:text-2xl font-semibold animate-fade-in-up">
                        <ReactTyped
                            strings={[
                                t("Innovative Plastic Solutions"),
                                t("Sustainable Manufacturing"),
                                t("Trusted Quality Since 2023"),
                            ]}
                            typeSpeed={50}
                            backSpeed={30}
                            loop
                        />
                    </div>
                    <div className="mx-auto flex flex-col sm:flex-row gap-4 justify-start mt-6">
                        <Link
                            to="/product"
                            className="bg-[#E56820] text-white px-6 py-3 rounded-full font-bold text-lg capitalize hover:bg-[#c55a1b] transition-transform duration-300 transform hover:scale-105"
                        >
                            {t("Explore Products")}
                        </Link>
                        <Link
                            to="/contact"
                            className="border-2 border-[#E56820] text-white px-6 py-3 rounded-full font-bold text-lg capitalize hover:bg-[#E56820] hover:text-white transition-transform duration-300 transform hover:scale-105"
                        >
                            {t("Contact Us")}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Landing;